import type React from "react";

import { useUser } from "../../../hooks";

interface InternalWithoutFallbackProps {
	readonly children: React.ReactNode;
	readonly fallback?: never;
}

interface InternalWithFallbackProps {
	readonly children?: React.ReactNode;
	readonly fallback: React.ReactNode;
}

type InternalProps = InternalWithoutFallbackProps | InternalWithFallbackProps;

export const Internal: React.FC<InternalProps> = ({ children = null, fallback = null }) => {
	const { isPacksizeUser } = useUser();

	if (isPacksizeUser === undefined) {
		return null;
	}

	if (isPacksizeUser === false) {
		return fallback;
	}

	return children;
};
